import { Easing } from 'motion';

import { LoyaltyTierName } from 'types/api/account.types';

//Always true (active in staging/prod)
export const IS_LOYALTY_ENABLED = true;

export const LOYALTY_EASING: Easing = [0.49, 0.03, 0.13, 0.99];
export const LOYALTY_BEZIER = 'cubic-bezier(0.49, 0.03, 0.13, 0.99)';

export const MAX_BENEFITS_BEFORE_EXTRA_SPACE = 6;

type TierConfig = {
  backgroundColor: string;
  intlId: string;
  borderColor: string;
  assetsColor: string;
  mixBlendMode: 'color-burn' | 'screen';
  subLayer?: string;
  gradientColor: {
    start: string;
    end: string;
  };
  textColor: string;
  textImage: string;
};

export const tierConfig: Record<LoyaltyTierName, TierConfig> = {
  Bronze: {
    backgroundColor: '#81592E',
    intlId: 'loyalty.tier.bronze.label',
    borderColor: 'rgba(150, 153, 147, 0.5)',
    assetsColor: '#969993',
    mixBlendMode: 'color-burn',
    gradientColor: {
      start: '#CA8D4E',
      end: '#93571E',
    },
    textColor: '#000',
    textImage: '/images/loyalty/img-card-title-bronze.webp',
  },
  Silver: {
    backgroundColor: '#C9C9C9',
    intlId: 'loyalty.tier.silver.label',
    borderColor: 'rgba(150, 153, 147, 0.5)',
    assetsColor: '#969993',
    mixBlendMode: 'color-burn',
    gradientColor: {
      start: '#EFE8E8',
      end: '#A8A8A8',
    },
    textColor: '#000',
    textImage: '/images/loyalty/img-card-title-silver.webp',
  },
  Gold: {
    backgroundColor: '#AB8A2E',
    intlId: 'loyalty.tier.gold.label',
    borderColor: 'rgba(150, 153, 147, 0.5)',
    assetsColor: '#969993',
    mixBlendMode: 'color-burn',
    gradientColor: {
      start: 'rgba(242, 204, 100, 0.90)',
      end: 'rgba(200, 149, 17, 0.90)',
    },
    textColor: '#000',
    textImage: '/images/loyalty/img-card-title-gold.webp',
  },
  Platinum: {
    backgroundColor: '#9AC8C2',
    intlId: 'loyalty.tier.platinum.label',
    borderColor: 'rgba(150, 153, 147, 0.5)',
    assetsColor: '#969993',
    mixBlendMode: 'color-burn',
    gradientColor: {
      start: '#C7FFEB',
      end: '#7ED2B3',
    },
    textColor: '#000',
    textImage: '/images/loyalty/img-card-title-platinum.webp',
  },
  Diamond: {
    backgroundColor: '#333333',
    intlId: 'loyalty.tier.diamond.label',
    borderColor: 'rgba(210, 244, 255, 0.2)',
    assetsColor: '#D2F4FF',
    mixBlendMode: 'screen',
    subLayer: '#8BE2FF',
    gradientColor: {
      start: '#D2F4FF',
      end: '#9BE6FF',
    },
    textColor: '#D2F4FF',
    textImage: '/images/loyalty/img-card-title-diamond.webp',
  },
  Royal: {
    backgroundColor: '#333333',
    intlId: 'loyalty.tier.royal.label',
    borderColor: 'rgba(57, 156, 114, 0.2)',
    assetsColor: '#399C72',
    mixBlendMode: 'screen',
    subLayer: '#004226',
    gradientColor: {
      start: '#399C72',
      end: '#075534',
    },
    textColor: '#399C72',
    textImage: '/images/loyalty/img-card-title-royal.webp',
  },
};
